import { LoadButton } from "./ui/LoadButton.js";
import { CertSelect } from "./ui/Select/CertSelectNew";
import * as Ladda from 'ladda';

$(() => {
    if ($("#certs").length > 0) {
        const certsSelect = new CertSelect($("#certs"));
        certsSelect.update();

        certsSelect.onSelect(cert => {
            const dataToSign = $("#form_data").val();
            signlib
                .eimzo()
                .sign(dataToSign, cert.serialNumber)
                .then(onSignSuccess, onSignErr);

        }, onSignErr);
    }

    function onSignErr(err) {
        const submitter = $('form button[type="submit"]');
        submitter.attr("disabled", true);
        toastr.warning(err);
    }

    /** @param {string} sign  */
    function onSignSuccess(sign) {
        $("#form_signedData").val(sign);
        const submitter = $('form button[type="submit"]');
        submitter.attr("disabled", false);
        submitter.click();
    }
});

